import { useLayoutEffect } from "react";

export const useWindowResize = (handler: () => void) => {
  useLayoutEffect(() => {
    window.addEventListener("resize", handler);

    return () => window.removeEventListener("resize", handler);
  }, [handler]);
};
